export default __webpack_public_path__ + "static/media/video-play-img.89389723.svg";